import React from 'react';

const format_percentage = number => `${ADV.util.number_format(number * 100, 2)}%`;

const MarketAssumptions = ({ assumptions }) => (
  <table className="market-assumptions">
    <thead>
      <th>Asset class</th>
      <th>Avg. return</th>
      <th>Volatility</th>
    </thead>
    <tbody>
      {assumptions.map(assumption => {
        return (
          <tr key={assumption.AssetClass}>
            <td>{assumption.AssetClass}</td>
            <td>{format_percentage(assumption.AverageReturn)}</td>
            <td>{format_percentage(assumption.Volatility)}</td>
          </tr>
        );
      })}
    </tbody>
  </table>
);

export default MarketAssumptions;
